import useAspidaSWR from '@aspida/swr';
import { apiClient } from '~/lib/apiClient';
import type { OrderPrizeCategory } from '~/types/resources/orderPrizeCategory';

type UseGachaPrizeCategories = {
  prizeCategories?: OrderPrizeCategory[];
  isLoading: boolean;
  error: any;
};

export const useGachaPrizeCategories = (
  gacha_id: string | null
): UseGachaPrizeCategories => {
  const { data, error } = useAspidaSWR(
    apiClient.v1.gachas._gachaId(gacha_id as string).prize_categories,
    { enabled: gacha_id != null }
  );

  return {
    prizeCategories: data,
    isLoading: !data && !error,
    error,
  };
};
